import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import { EMPTY_STRING, SIDEBAR_BUTTONS } from "../../../constants";
import {
  systemConstants,
  ROLES,
  globalConstants,
  routesPathConstants,
} from "../../../constants";
import SidebarFooter from "./SidebarFooter";
import { STORE_CARD_PAYMENT_TYPE_ENUMS } from "../../../system/globalEnums";
import {
  AdminIcon,
  AnalyticsIcon,
  CustomersIcon,
  DashboardIcon,
  EmployeesIcon,
  InventoryIcon,
  SellTradeIcon,
  SettingsIcon,
} from "../../../assets/icons/iconsProvider";
import {
  createCompanyDynamicUrl,
  isAdminLogin,
  isEmployeeLogin,
  getIsHideNonInventoryOptions,
  isShopifyIntegrationEnabled,
} from "../../../shared/utility";

const SidebarBody = (props) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { activeSidebarBtn, setActiveSidebarBtn } = props;
  const isHideNonInventoryOptions = getIsHideNonInventoryOptions(
    props.currentStore
  );
  useEffect(() => {
    let path = String(pathname).toLowerCase();
    switch (true) {
      case path.includes(
        String(
          SIDEBAR_BUTTONS.SELL_AND_TRADE.replaceAll("_", EMPTY_STRING)
        ).toLowerCase()
      ):
        setActiveSidebarBtn(SIDEBAR_BUTTONS.SELL_AND_TRADE);
        break;
      case path.includes(String(SIDEBAR_BUTTONS.INVENTORY).toLowerCase()):
        setActiveSidebarBtn(SIDEBAR_BUTTONS.INVENTORY);
        break;
      case path.includes(String(SIDEBAR_BUTTONS.ANALYTICS).toLowerCase()):
        setActiveSidebarBtn(SIDEBAR_BUTTONS.ANALYTICS);
        break;
      case path.includes(String(SIDEBAR_BUTTONS.USERS).toLowerCase()):
        setActiveSidebarBtn(SIDEBAR_BUTTONS.USERS);
        break;
      case path.includes(String(SIDEBAR_BUTTONS.CUSTOMERS).toLowerCase()):
        setActiveSidebarBtn(SIDEBAR_BUTTONS.CUSTOMERS);
        break;
      case path.includes(String(SIDEBAR_BUTTONS.SETTINGS).toLowerCase()):
        setActiveSidebarBtn(SIDEBAR_BUTTONS.SETTINGS);
        break;
      case path.includes(String(SIDEBAR_BUTTONS.ADMIN).toLowerCase()):
        setActiveSidebarBtn(SIDEBAR_BUTTONS.ADMIN);
        break;
      case path.includes(String(SIDEBAR_BUTTONS.ORDERS).toLowerCase()):
        setActiveSidebarBtn(SIDEBAR_BUTTONS.ORDERS);
        break;
      default:
        setActiveSidebarBtn(SIDEBAR_BUTTONS.DASHBOARD);
    }
    // eslint-disable-next-line
  }, [pathname]);

  return (
    <div className="d-flex flex-column h-100">
      <ul className="m-0 p-0 d-flex flex-column justify-content-start align-items-center">
        {!isEmployeeLogin(props.user) && !isHideNonInventoryOptions && (
          <li
            className={`${
              activeSidebarBtn === SIDEBAR_BUTTONS.DASHBOARD &&
              "active-sidebar-btn"
            } d-flex justify-content-center align-items-center flex-column`}
            onClick={() => {
              navigate(createCompanyDynamicUrl(routesPathConstants.DASHBOARD));
            }}
          >
            <DashboardIcon />
            Dashboard
          </li>
        )}
        {!isHideNonInventoryOptions && (
          <li
            className={`${
              activeSidebarBtn === SIDEBAR_BUTTONS.SELL_AND_TRADE &&
              "active-sidebar-btn"
            } d-flex justify-content-center align-items-center flex-column`}
            onClick={() => {
              navigate(
                createCompanyDynamicUrl(routesPathConstants.SELL_AND_TRADE)
              );
            }}
          >
            <SellTradeIcon />
            Sell/Trade
          </li>
        )}
        <li
          className={`${
            activeSidebarBtn === SIDEBAR_BUTTONS.INVENTORY &&
            "active-sidebar-btn"
          } d-flex justify-content-center align-items-center flex-column`}
          onClick={() => {
            navigate(createCompanyDynamicUrl(routesPathConstants.INVENTORY));
          }}
        >
          <InventoryIcon />
          Inventory
        </li>
        {isHideNonInventoryOptions &&
          isShopifyIntegrationEnabled(props?.currentStore) && (
            <li
              className={`${
                activeSidebarBtn === SIDEBAR_BUTTONS.ORDERS &&
                "active-sidebar-btn"
              } d-flex justify-content-center align-items-center flex-column`}
              onClick={() => {
                navigate(createCompanyDynamicUrl(routesPathConstants.ORDERS));
              }}
            >
              <SellTradeIcon />
              Online Orders
            </li>
          )}
        {!isEmployeeLogin(props.user) && !isHideNonInventoryOptions && (
          <li
            className={`${
              activeSidebarBtn === SIDEBAR_BUTTONS.ANALYTICS &&
              "active-sidebar-btn"
            } d-flex justify-content-center align-items-center flex-column`}
            onClick={() => {
              navigate(
                createCompanyDynamicUrl(
                  routesPathConstants.ANALYTICS_SALES_SUMMARY
                )
              );
            }}
          >
            <AnalyticsIcon />
            Analytics
          </li>
        )}
        <li
          className={`${
            activeSidebarBtn === SIDEBAR_BUTTONS.CUSTOMERS &&
            "active-sidebar-btn"
          } d-flex justify-content-center align-items-center flex-column`}
          onClick={() => {
            navigate(createCompanyDynamicUrl(routesPathConstants.CUSTOMERS));
          }}
        >
          <CustomersIcon />
          Customers
        </li>
        {/* {!isEmployeeLogin(props.user) && (
          <li
            className={`${
              activeSidebarBtn === SIDEBAR_BUTTONS.USERS && "active-sidebar-btn"
            } d-flex justify-content-center align-items-center flex-column`}
            onClick={() => {
              navigate(
                createCompanyDynamicUrl(routesPathConstants.SETTINGS_USERS)
              );
            }}
          >
            <EmployeesIcon />
            Users
          </li>
        )} */}
        <li
          className={`${
            activeSidebarBtn === SIDEBAR_BUTTONS.SETTINGS &&
            "active-sidebar-btn"
          } d-flex justify-content-center align-items-center flex-column`}
          onClick={() => {
            navigate(
              createCompanyDynamicUrl(
                isEmployeeLogin(props.user)
                  ? routesPathConstants.SETTINGS_PRINTER_SETTINGS
                  : isHideNonInventoryOptions
                  ? routesPathConstants.SETTINGS_ITEM_ORGANIZATION
                  : routesPathConstants.SETTINGS_DISCOUNT
              )
            );
          }}
        >
          <SettingsIcon />
          Settings
        </li>
        {isAdminLogin(props.user) && (
          <li
            className={`${
              activeSidebarBtn === SIDEBAR_BUTTONS.ADMIN && "active-sidebar-btn"
            } d-flex justify-content-center align-items-center flex-column`}
            onClick={() => {
              navigate(createCompanyDynamicUrl(routesPathConstants.ADMIN));
            }}
          >
            <AdminIcon />
            Admin
          </li>
        )}
      </ul>
      <SidebarFooter />
    </div>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  activeSidebarBtn: state.system.activeSidebarBtn,
  user: state.authentication.user,
  currentStore: state.store.currentStore,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  setActiveSidebarBtn: (data) =>
    dispatch({ type: systemConstants.SET_ACTIVE_SIDEBAR_BTN, data: data }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SidebarBody);
